import { db } from "@/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

const getDefaultState = () => {
  return {
    estate: {},
    estates: [],
    status: {},
    waiting: false,
  };
};

const state = getDefaultState();

const actions = {
  async getEstate({ commit }, id) {
    try {
      commit("wait");
      const docRef = doc(db, "estates", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const estate = docSnap.data();
        estate.id = docSnap.id;
        commit("setEstate", estate);
      }
    } catch (error) {
      commit("failure", error);
    }
  },
  async getEstates({ commit }, companyId) {
    try {
      commit("wait");
      const q = query(
        collection(db, "estates"),
        where("partnerIds", "array-contains", companyId)
      );
      const querySnapshot = await getDocs(q);
      const estates = querySnapshot.docs.map((doc) => {
        const estate = doc.data();
        estate.id = doc.id;
        return estate;
      });

      commit("setEstates", estates);
    } catch (error) {
      commit("failure", error);
    }
  },
};

const mutations = {
  failure(state, error) {
    state.status.error = error;
    setTimeout(() => {
      state.status = {};
    }, 100);
    state.waiting = false;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setEstate(state, estate) {
    state.estate = estate;
    state.waiting = false;
  },
  setEstates(state, estates) {
    state.estates = estates;
    state.waiting = false;
  },
  setSuccess(state, code) {
    state.status.success = { code };
    setTimeout(() => {
      state.status = {};
    }, 100);
  },
  wait(state) {
    state.waiting = true;
  },
};

const getters = {
  getEstate(state) {
    return state.estate;
  },
};

const estate = {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default estate;
